import React from "react";

const MinusIcon = ({name, color, size}) => (
    <svg viewBox="0 0 42 42" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M0 20h42v2H0z" />
    </svg>
);

export default MinusIcon;